export default "__VITE_ASSET__C2rpZ5dQ__"